module.exports = __webpack_public_path__ + "static/Foundation Photo-63b9152294ee0514aaea429be73c9b92.jpg";